export const truncateString = (str: string | undefined | null, maxLength: number) => {
  if (!str) return ''
  if (str && str.length > maxLength) {
    return str.slice(0, maxLength) + '...'
  } else {
    return str
  }
}
